export const QUERY_KEY = {
  GET_OPERATION_AND_REQUIRED_DOCUMENTS:
    'minor-holder-details-and-required-documents',
};
